<template>
  <div class="modern-stats-row">
    <!-- BPM à gauche -->
    <div class="stat-col">
      <div class="circle-outer">
        <svg viewBox="0 0 60 60" class="stat-svg">
          <circle cx="30" cy="30" r="26" class="gauge-bg" />
        </svg>
        <div class="stat-main-value">{{ session.BpmCC }}</div>
      </div>
      <div class="stat-label">BPM moyen</div>
    </div>

    <!-- Les pourcentages au centre -->
    <div class="stat-col stat-col-center">
      <div class="pct-row">
        <div class="pct-block optimal">
          <div class="pct-value">{{ session.Pct3 }}%</div>
          <div class="pct-label">Opt.</div>
        </div>
        <div class="pct-block moderate">
          <div class="pct-value">{{ session.Pct2 }}%</div>
          <div class="pct-label">Mod.</div>
        </div>
        <div class="pct-block low">
          <div class="pct-value">{{ session.Pct1 }}%</div>
          <div class="pct-label">Faible</div>
        </div>
      </div>
      <div class="stat-label stat-label-center">Répartition</div>
    </div>

    <!-- Cohérence cardiaque moyenne à droite -->
    <div class="stat-col">
      <div class="circle-outer">
        <svg viewBox="0 0 60 60" class="stat-svg">
          <circle cx="30" cy="30" r="26" class="gauge-bg" />
          <circle
            cx="30"
            cy="30"
            r="26"
            :class="'gauge-cc'"
            :stroke="ccColor"
          />
        </svg>
        <div class="stat-main-value" :style="{ color: ccColor }">
          {{ session.AverageCC }}%
        </div>
      </div>
      <div class="stat-label">Cohérence</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MedicalSessionStatsSimple",
  props: {
    session: { type: Object, required: true }
  },
  computed: {
    ccColor() {
      // Règle de couleur pour la CC
      const cc = this.session.AverageCC;
      if (cc < 60)  return "#FE0000";
      if (cc < 90)  return "#FFC801";
      return "#51C901";
    }
  }
};
</script>

<style scoped>
.modern-stats-row {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 28px;
  padding: 24px 0 0 0;
  background: transparent;
}
.stat-col {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
.stat-col-center {
  min-width: 180px;
  max-width: 240px;
  justify-content: center;
}
.circle-outer {
  position: relative;
  width: 60px;
  height: 60px;
}
.stat-svg {
  width: 60px;
  height: 60px;
  display: block;
}
.gauge-bg {
  fill: none;
  stroke: #e2e8f0;
  stroke-width: 7;
}
.gauge-cc {
  fill: none;
  stroke-width: 7;
  stroke-linecap: round;
  transition: stroke 0.3s;
}
.stat-main-value {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -54%);
  font-size: 22px;
  font-weight: 700;
  font-family: 'Inter', system-ui, sans-serif;
  color: #334155;
  text-shadow:0 0 3px #fff8;
  letter-spacing: -0.03em;
}
.stat-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  margin-top: 2px;
  text-align: center;
  letter-spacing: 0.01em;
}
.stat-label-center {
  margin-top: 8px;
  font-weight: 600;
}

.pct-row {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 22px;
  margin-top: 6px;
}
.pct-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 42px;
}
.pct-value {
  font-size: 21px;
  font-weight: 700;
  font-family: 'Inter', system-ui, sans-serif;
}
.pct-block.optimal .pct-value { color: #10b981; }
.pct-block.moderate .pct-value { color: #ffc801; }
.pct-block.low .pct-value { color: #FE0000; }
.pct-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin-top: 1px;
  letter-spacing: 0.01em;
}

/* Cercle Cohérence Cardiaque (droite) */
.gauge-cc {
  stroke-dasharray: 163.362;
  stroke-dashoffset: 0;
}

@media (max-width: 800px) {
  .modern-stats-row { flex-direction: column; gap: 18px; }
  .stat-col-center { min-width: unset; max-width: unset; }
}
</style>